import Model from 'models/Model'
import { currency, date } from 'helpers/format'

// Methods
export const DEPOSIT = ['P', 'M', 'X', 'H', 'R']
export const BANK = ['O', 'B', '7']
export const GCASH = ['5']
export const PAYMENT_METHODS = [
  {
    value: BANK.join(','),
    label: 'Bank Transfer',
  },
  {
    value: GCASH.join(','),
    label: 'GCash',
  },
  {
    value: DEPOSIT.join(','),
    label: 'Cheque Deposit',
  },
]

// Statuses
export const PAID = 'paid'
export const PAID_LABEL = 'Paid'
export const PAID_COLOR = '#2F9BAA'
export const PENDING = 'pending'
export const PENDING_LABEL = 'Pending'
export const PENDING_COLOR = '#FA6383'
export const PAYMENT_STATUSES = [
  {
    value: PAID,
    label: PAID_LABEL,
  },
  {
    value: PENDING,
    label: PENDING_LABEL,
  },
]

export default class Payment extends Model {
  get id() {
    return this.model.id
  }

  get createdAt() {
    return date(this.model.postingDate)
  }

  get netAmount() {
    return currency(this.model.netAmount)
  }

  get grossAmount() {
    return currency(this.model.grossAmount)
  }

  get paymentNumber() {
    return this.model.paymentNumber
  }

  get method() {
    if (DEPOSIT.includes(this.model.paymentMethod)) {
      return 'Cheque Deposit'
    }

    if (BANK.includes(this.model.paymentMethod)) {
      return 'Bank Transfer'
    }

    if (GCASH.includes(this.model.paymentMethod)) {
      return 'GCash'
    }

    return this.model.paymentMethod
  }

  get paymentMethod() {
    return this.model.paymentMethod
  }

  get status() {
    if (this.model.status === PAID) {
      return PAID_LABEL
    }
    if (this.model.status === PENDING) {
      return PENDING_LABEL
    }

    return this.model.status
  }

  get statusColor() {
    const status = this.model.status
    if (status && status.toLowerCase() === PAID) {
      return PAID_COLOR
    }

    if (status && status.toLowerCase() === PENDING) {
      return PENDING_COLOR
    }

    return ''
  }

  get paymentDescription() {
    return this.model.paymentDescription
  }

  get statusInPaymentSummary() {
    return this.model.paymentStatus || this.model.status
  }

  get isAcknowledged() {
    return this.model.acknowledgeStatus
  }

  get soaStatus() {
    if (this.isAcknowledged) {
      return 'Acknowledged'
    }

    return 'Unopened'
  }

  get soaStatusColor() {
    if (this.isAcknowledged) {
      return PAID_COLOR
    }

    return '#939393'
  }

  get withOR() {
    return this.model.orUpload
  }

  get withORColor() {
    if (this.withOR) {
      return PAID_COLOR
    }

    return PENDING_COLOR
  }

  get orUploadedAt() {
    return date(this.model.uploadDate)
  }

  get paymentReceived() {
    return this.model.paymentReceived
  }

  get paymentReceivedAt() {
    return date(this.model.paymentReceivedDate)
  }

  get paymentReceivedDate() {
    return date(this.model.paymentReceivedDate)
  }

  get paymentReceivedColor() {
    if (this.paymentReceived) {
      return PAID_COLOR
    }

    return PENDING_COLOR
  }

  get ref() {
    if (this.isCheckDelivery) {
      return this.model.checkNo
    }

    if (this.isGCash) {
      return this.model.gcashReferenceNo
    }

    if (this.isBank) {
      return this.model.customerRef
    }

    return ''
  }

  get isCheckDelivery() {
    return DEPOSIT.includes(this.model.paymentMethod)
  }

  get isGCash() {
    return GCASH.includes(this.model.paymentMethod)
  }

  get isBank() {
    return BANK.includes(this.model.paymentMethod)
  }
}
